import { CompetitionLevel } from './competition-level'
import { Injectable } from '@angular/core'

@Injectable()
export class CompetitionLevelSerializer {
  fromJson(json: any): CompetitionLevel {
    const competitionLevel = {
      ...json
    }

    return competitionLevel
  }

  toJson(competitionLevel: CompetitionLevel): any {
    return {
      ...competitionLevel
    }
  }
}
